import { render, staticRenderFns } from "./ModalMaxPin.vue?vue&type=template&id=8137f970&"
import script from "./ModalMaxPin.vue?vue&type=script&lang=js&"
export * from "./ModalMaxPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports